export enum CredentialingSubEntityType {
  PROVIDER = 1,
  UNDERGRADUATE = 2,
  GRADUATE = 3,
  INTERNSHIP = 4,
  RESIDENCY = 5,
  EXTERNSHIP = 6,
  FELLOWSHIP = 7,
  ECMFG = 8,
  ACADEMIC_AFFILIATION = 9,
  EMPLOYMENT_HISTORY = 10,
  HOSPITAL_AFFILIATION = 11,
  TIME_GAP_EXPLANATION = 12,
  REFERENCE = 13,
  MALPRACTICE = 14,
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/enums/CredentialingSubEntityType.ts